<template>
  <div class="collection-cards" v-if="results">
    <template v-for="(item,i) in results" :key="`collection-card_${i}`">
      <div class="collection-card__container">
        <div class="collection-card" :style="calculated_img(item,i)">
          <a :href="`/search/collection/${item.slug}`">
            <div class="collection-card__title" v-html="item.title"></div>
            <div class="btn btn-blue btn-rounded">{{ $filters.capitalizeFirstLetter(item.type) }} collection</div>
          </a>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
	import algoliasearch from 'algoliasearch';

	export default {
		props: {
			filterType: {
				type: String,
				default: 'job'
			},
			filterFeatured: {
				type: String,
				default: null
			},
			hits: {
				type: Number,
				default: 3 // More likely this is 6 being passed in.
			}
		},

		data() {
			return {
				client: false,
				index: false,
				index_name: (this.$config.test_env) ? 'collections-dev' : 'collections-live',
				searchObject: {
					hitsPerPage: this.hits,
					facets: ["publishied"],
					facetFilters: [["publishied:true"]] // Includes typo on published
				},
				results: false
			}
		},

		methods: {
			calculated_img(item,index) {
				if (item.image !== "") {
					return 'background-image: url('+this.$filters.analyseImage(item.image,'herosearchxs','herosearchsm')+');';
				}
				return 'background-image: url(/images/collections/collection-bg-'+(index+1)+'.jpg?'+this.$config.version+')';
			}
		},

		created() {
			this.client = algoliasearch(this.$config.algolia.app_id, this.$config.algolia.app_key);
			this.index = this.client.initIndex(this.index_name);

			this.index
				.search('', this.searchObject)
				.then((results) => {
					//console.log("we got initial hits:",results.hits,results.nbHits);
					console.log("job collection search raw results:", results);
					if (results.nbHits > 0) {
						this.results = results.hits;
					} else {
						this.results = false;
					}
				});
		}
	}
</script>
